<template>

    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增</el-button>

            <div style="margin-right: 20px">
                <el-input

                        size="mini"
                        style="width: 200px "
                        placeholder="请输入搜索内容"
                        v-model="Searchdata"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Searchrevise" size="mini"></el-button>
            </div>
        </div>
        <el-table
                id="eltable"

                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="fName"
                    label="部门"
                    width="140"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="gName"
                    label="车间"
                    width="140"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="type"
                    label="轮班类型"
                    width="110"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.type==1?'固定班':(scope.row.type==2?'三班两倒':(scope.row.type==3?'四班三倒':(scope.row.type==4?'两班两倒':'无')))}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="positionTime"
                    label="时间段"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="duration"
                    label="时长(h)"
                    width="70"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="elasticTime"
                    label="弹性时间(min)"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="bzNames"
                    label="轮班班组"
                    width="300"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="bcNotes"
                    label="班次"
                    width="140"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="state"
                    label="状态"
                    width="60"
                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <div>
                        {{scope.row.state==1?'启用':'未启用'}}

                    </div>

                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="130"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="vc_lruname"
                    label="录入人"
                    width="70"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    width="130"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
<!--                        <el-button style="color:#E6A23C;"  type="text" size="mini" @click="cancel(scope.row)">{{scope.row.state==1?'禁用':'启用'}}</el-button>-->
                        <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"

                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="100px"
                width="710px"
                height="300"
                :title="title"
                :visible.sync="addshiftdialog"
                v-if="addshiftdialog"
        >
            <AddShift  @shiftlist="shiftlist" :editData="editData" @close="close"></AddShift>

        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import AddShift from "./component/addShift";

    export default{
        name:'ShiftSetup',
        components:{

            AddShift,

        },

        data(){
            return{

                bztype:[
                    {
                        id:1,
                        value:'固定班'
                    },
                    {
                      id:4,
                      value:'两班两倒'
                    },
                    {
                        id:2,
                        value:'三班两倒'
                    },{
                    id:3,
                        value:'四班三倒'
                    }
                ],
                editData:{},
                addshiftdialog:false,//编辑弹框
                Searchdata:'',//搜索内容
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })

            //公共样式
            this.baseerp=baseerp
            this.shiftlist()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            close(){
                this.addshiftdialog=false
            },
            //页面搜索
            Searchrevise(){
                this.shiftlist()
                this.currentPage=1
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.shiftlist()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.shiftlist()
            },
            //新增
            add(){

                this.title='新增'

                this.editData={
                    duration:0,
                    id:0,
                    bids:[],
                    sjddata:[{
                        start: '',
                        end: '',
                        bc: ''
                    }],
                    state:1,
                    fName:'',
                    gName:'',
                    cbopen:0,
                    // name:'',
                    // jsonData:'',
                    // describe:'',
                    lruid:parseFloat(sessionStorage.getItem("userid")) ,
                    lruName:sessionStorage.getItem('lruname'),
                    // state:1
                    elasticTime:0,
                }
                this.addshiftdialog=true
            },
            //编辑
            edit(val){
                this.title='编辑'
                // console.log(val)
                // this.editData.id=val.id
                this.editData=Object.assign({},val);
                // console.log(val)
                this.addshiftdialog=true
                // this.getServiceConfigDetail()

                // console.log(this.editData)
            },
            //确认作废
            submitdel(){
                this.shiftdelete()

                // console.log(this.editData)
                this.delDialogVisible=false
            },
//作废
            async cancel(Val){
                // console.log(Val)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }


                let params = {
                    id:Val.id,
                    state:Val.state==1?0:1
                }
                let res = await API.cancel(params);
                if (res.code == 1) {
                    this.$message({
                        message: Val.state==1?'禁用成功':'启用成功',
                        type: 'success'
                    });
                    this.shiftlist()
                    // this.tableData=res.data.list
                    // this.total=res.data.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async shiftdelete(){
                // console.log(Val)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    state:-1
                }
                let res = await API.shiftdelete(params);
                if (res.code == 1) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.shiftlist()
                    // this.tableData=res.data.list
                    // this.total=res.data.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            del(val){
                this.title='删除'
                this.editData=val
                this.deldetail='是否要删除'

                // this.templateUsed()
                this.delDialogVisible=true

                // console.log(this.editData)
                // console.log(this.editData.id)
            },
            //业务配置详情查询
            // async getServiceConfigDetail() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         id:this.editData.id
            //     }
            //     let res = await API.getServiceConfigDetail(params);
            //     if (res.code == 1) {
            //         this.editData=res.detail
            //         this.bianjipingtai=true
            //         this.editData.xfname=this.consumername
            //         // this.editData.enble=val.state
            //         this.editData.ywlxOld=res.detail.ywlx
            //         this.editData=Object.assign({},res.detail);
            //         // console.log(res)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
            //业务配置列表查询
            async shiftlist() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }
                let res = await API.shiftlist(params);
                if (res.code == 1) {
                    this.tableData=res.data.list
                    this.total=res.data.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //作废验证
            async templateUsed() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.templateUsed(params);
                if (res.code == 1) {
                    this.deldetail='是否要删除'
                    // console.log(res)
                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    // console.log(res)
                    this.deldetail=res.message

                    // this.$message.error(res.message);
                }
            },
            //业务配置作废
            async voidTemplate() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    // ywlx:this.editData.ywlx,
                    id:this.editData.id
                }
                let res = await API.voidTemplate(params);
                if (res.code == 1) {

                    this.getTemplatesList()

                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },


        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>